import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { getAnonymousToken, selectedUser } from '../../features/auth/authSlice';
import { DisplayUser } from '../../features/auth/models/DisplayUser.interface';
import { discoveryState } from '../../features/discovery/discoverySlice';
import cookieService from '../../features/auth/services/cookie.service';

export const useIdentity = (): [boolean, DisplayUser | null] => {
    const dispatch = useAppDispatch();
    const { isLoading, identity } = useAppSelector(selectedUser);
    const { isSuccess } = useAppSelector(discoveryState);
    const token = cookieService.get(process.env.REACT_APP_TOKEN_NAME as string);

    useEffect(() => {
        if (token) {
            return;
        }
        if (isSuccess && !isLoading && !identity) {
            dispatch(getAnonymousToken());
        }
    }, [isSuccess]);

    return [isLoading, identity];
}
